import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import axiosInstance from '../../../services/api/API';
import './index.scss';

const SalesPerformance = ({SalesPerformanceData}) => {
  const [data, setData] = useState({
    prevMonth: {
      conversionRate: 0,
      leadsConverted: 0,
      totalIncome: 0,
      productivity: 0,
      callsPerHour: 0,
    },
    currentMonth: {
      conversionRate: 0,
      leadsConverted: 0,
      totalIncome: 0,
      productivity: 0,
      callsPerHour: 0,
    },
  });

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchSalesPerformanceData();
  }, []);

  const fetchSalesPerformanceData = async () => {
    try {
      const response = await axiosInstance.get("/sales/performance", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedData = response.data.data;
      setData({
        prevMonth: {
          conversionRate: fetchedData.prevMonth.conversionRate,
          leadsConverted: fetchedData.prevMonth.leadsConverted,
          totalIncome: fetchedData.prevMonth.totalIncome,
          productivity: fetchedData.prevMonth.productivity,
          callsPerHour: fetchedData.prevMonth.callsPerHour,
        },
        currentMonth: {
          conversionRate: fetchedData.currentMonth.conversionRate,
          leadsConverted: fetchedData.currentMonth.leadsConverted,
          totalIncome: fetchedData.currentMonth.totalIncome,
          productivity: fetchedData.currentMonth.productivity,
          callsPerHour: fetchedData.currentMonth.callsPerHour,
        },
      });

    } catch (error) {
      console.error("Error fetching sales performance data:", error);
    }
  };

  const getValueColor = (currentValue ) => {
    if (currentValue >=0) {
      return 'green';
    } else  {
      return 'red';
    
    }
  };

  return (
    <div className='salesPerformanceContainer'>
      <Row className="salesPerformanceRow">
        <span className='salesPerformanceHeader'>Sales Performance</span>
        <Col md={4} xs={12} className="salesPerformanceCard">
          <Card className="sales-performance-card">
            <Card.Header>Conversion Rate</Card.Header>
            <Card.Body>
              <Row className="d-md-flex d-block mb-3">
                <Col md={6} xs={12}>
                  <span className="monthtitle">Previous Month -{SalesPerformanceData?.last_month}</span>
                  <div className="d-flex justify-content-around prevcurrMonth">
                    <p className="per-value" style={{ color: getValueColor(SalesPerformanceData?.previous_convertedgrowthrate) }}>
                      {SalesPerformanceData.previousmonthconvertedleadpercent}%
                    </p>
                    <div style={{ height: '50px', width: 1, backgroundColor: 'grey' }}></div>
                    <div className="convertedleadscontainer">
                      <p className='salestotalvalue'>{SalesPerformanceData?.previousmonthconvertedlead}</p>
                      <p className='convertedtitle'>Leads Converted</p>
                    </div>
                  </div>
                   <div>
                    <span className='perfromlastmonth'><span style={{ color: getValueColor(SalesPerformanceData?.previous_convertedgrowthrate)}}>{SalesPerformanceData?.previous_convertedgrowthrate}%</span> from {SalesPerformanceData?.lasttolast_month} Month</span>
                  </div>
                </Col>
                <Col md={6} xs={12} className="currentmonth">
                  <span className="monthtitle">Current Month - {SalesPerformanceData?.current_month}</span>
                  <div className="d-flex justify-content-around prevcurrMonth">
                    <p className="per-value" style={{ color: getValueColor(SalesPerformanceData?.currentconvertedgrowthrate) }}>
                      {SalesPerformanceData?.currentmonthconvertedleadpercent}%
                    </p>
                    <div style={{ height: '50px', width: 1, backgroundColor: 'grey' }}></div>
                    <div className="convertedleadscontainer">
                      <p className='salestotalvalue'>{SalesPerformanceData?.currentmonthconvertedlead}</p>
                      <p className='convertedtitle'>Leads Converted</p>
                    </div>
                  </div>
                  <div>
                    <span className='perfromlastmonth'><span style={{ color: getValueColor(SalesPerformanceData?.currentconvertedgrowthrate)}}>{SalesPerformanceData?.currentconvertedgrowthrate}%</span> from {SalesPerformanceData?.last_month} Month</span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} xs={12} className="salesPerformanceCard">
          <Card className="sales-performance-card">
            <Card.Header>Total Income</Card.Header>
            <Card.Body>
              <Row className="d-md-flex d-block mb-3">
                <Col md={6} xs={12}>
                  <span className='monthtitle'>Previous Month - {SalesPerformanceData?.last_month}</span>
                  <p className='preMonthIncome per-value' style={{  margin: 0, color: getValueColor(SalesPerformanceData?.previous_incomegrowthrate) }}>
                    ₹{SalesPerformanceData?.previous_income} /-
                  </p>
                   <div>
                    <span className='perfromlastmonth'><span style={{color: getValueColor(SalesPerformanceData?.previous_incomegrowthrate)}}>{SalesPerformanceData?.previous_incomegrowthrate}%</span> from {SalesPerformanceData?.lasttolast_month} Month</span>
                  </div>
                </Col>
                <Col md={6} xs={12} className="currentmonth">
                  <span className='monthtitle'>Current Month - {SalesPerformanceData?.current_month}</span>
                  <p className='preMonthIncome per-value' style={{ margin: 0, color: getValueColor(SalesPerformanceData?.previous_incomegrowthrate) }}>
                    ₹{SalesPerformanceData?.income} /-
                  </p>
                   <div>
                    <span className='perfromlastmonth'><span style={{color: getValueColor(SalesPerformanceData?.previous_incomegrowthrate)}}>{SalesPerformanceData?.incomegrowthrate}%</span> from {SalesPerformanceData?.last_month} Month</span>
                  </div>
                

                </Col>
                
              </Row>
              

            </Card.Body>
          </Card>
          
        </Col>
       
         
        
        <Col md={4} xs={12} className="salesPerformanceCard">
          <Card className="sales-performance-card">
            <Card.Header>Productivity Metrics</Card.Header>
            <Card.Body>
              <Row className="d-md-flex d-block mb-3">
                <Col md={6} xs={12}>
                  <span className="monthtitle">Previous Month - {SalesPerformanceData?.last_month}</span>
                  
                    <p className="per-value preMonthIncome" style={{margin:0, color: getValueColor(SalesPerformanceData?.previous_metricsgrowthrate) }}>
                      {SalesPerformanceData?.previous_metrics}<p className='calltitle per-value'>Calls Per Hour</p>
                    </p>
                     
                    
                    {/* <div style={{ height: '50px', width: 1, backgroundColor: 'grey' }}></div> */}
                   
                 
                   <div>
                    <span className='perfromlastmonth'><span style={{ color: getValueColor(SalesPerformanceData?.previous_metricsgrowthrate) }}>{SalesPerformanceData?.previous_metricsgrowthrate}%</span> from {SalesPerformanceData?.lasttolast_month} Month</span>
                  </div>
                </Col>
                <Col md={6} xs={12}>
                  <span className="monthtitle">Current Month - {SalesPerformanceData?.current_month}</span>
                  
                    <p className="per-value preMonthIncome" style={{ color: getValueColor(data.prevMonth.productivity, data.currentMonth.productivity) }}>
                      {SalesPerformanceData?.metrics} <p className='per-value calltitle'>Calls Per Hour</p>
                    </p>
                    {/* <div style={{ height: '50px', width: 1, backgroundColor: 'grey' }}></div> */}
                   
                      {/* <p className='salestotalvalue'>{SalesPerformanceData?.metrics}</p> */}
                     
                    
                  
                   <div>
                    <span className='perfromlastmonth'><span style={{ color: getValueColor(SalesPerformanceData?.previous_metricsgrowthrate) }}>{SalesPerformanceData?.metricsgrowthrate}%</span> from {SalesPerformanceData?.last_month}  Month</span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SalesPerformance;
